export default {
    editTitle: 'Modifier l\'utilisateur',
    editSubtitle: 'Modifier le rôle et les autorisations de l\'utilisateur',
};